import { tv } from 'tailwind-variants'

const ANIMATION = 'duration-150 ease-out'

export const accordionVariants = tv({
  slots: {
    root: 'flex flex-col',
    header: 'm-0 flex p-0',
    trigger: [
      'group/trigger flex w-full cursor-pointer select-none items-center gap-2 bg-transparent text-left',
      'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-main',
      'data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50',
    ],
    indicator: ['transition-transform', ANIMATION],
    panel: [
      'overflow-hidden',
      'h-[var(--accordion-panel-height)]',
      `transition-[height] ${ANIMATION}`,
      'data-[starting-style]:h-0',
      'data-[ending-style]:h-0',
    ],
    label: 'min-w-0',
    contentInner: '',
  },
  variants: {
    variant: {
      inline: {
        trigger: 'py-2',
        indicator: 'group-data-[panel-open]/trigger:rotate-180',
        panel: 'rounded-md',
        label: 'transition-colors group-hover/trigger:text-text-primary',
        contentInner: 'bg-paper-elevation3 p-4',
      },
      card: {
        root: 'overflow-hidden rounded-md border border-divider bg-paper-elevation2',
        trigger: 'px-4 py-3 [&:not([data-panel-open])]:hover:bg-gradient-primary-vertical',
        indicator: 'group-data-[panel-open]/trigger:rotate-[180deg]',
        contentInner: 'px-4 pb-4 pt-2',
      },
    },
    /**
     * Trigger row height. `medium` (default) keeps the existing compact row;
     * `large` is the 48px touch row the mobile drawers use, where the title also
     * steps up to 16px — `Accordion.Title` reads the same size to pick it.
     */
    size: {
      medium: {},
      large: {
        trigger: 'min-h-12',
      },
    },
  },
  defaultVariants: {
    variant: 'inline',
    size: 'medium',
  },
})

export type AccordionVariant = 'inline' | 'card'
export type AccordionSize = 'medium' | 'large'
